import { useMemo, useEffect, useState } from 'react';
import { API_ADSENSE_ADUNITS_BJ } from '~global-api/bj.api';

const useAdSense = ({ adType }) => {
  const [adSenseUnits, setAdSenseUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdSenseUnits = async () => {
      try {
        setLoading(true);
        const response = await API_ADSENSE_ADUNITS_BJ();
        const data = response.data;

        if (data.success) {
          setAdSenseUnits(data.data || []);
        } else {
          setError('Failed to fetch AdSense units');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching AdSense units:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAdSenseUnits();
  }, []);

  const validAdSenseUnit = useMemo(() => {
    if (!adType || !adSenseUnits.length) {
      return null;
    }

    const matchingUnit = adSenseUnits.find(
      (unit) => unit.type === adType && unit.is_active && !unit.is_deleted,
    );

    return matchingUnit || null;
  }, [adSenseUnits, adType]);

  return {
    validAdSenseUnit,
    loading,
    error,
    hasAdSenseUnit: !!validAdSenseUnit,
  };
};

export { useAdSense };
